import { ImportSkillsStep, ImportSkillsStepI } from '@core/tellent-skills-types';
import { DialogWidth } from '@core/user-interface-legacy';

import { ImportSkillsIntroDialogComponent } from '../import-skills-intro-dialog/import-skills-intro-dialog.component';
import { ImportSkillsLoadingDialogComponent } from '../import-skills-loading-dialog/import-skills-loading-dialog.component';
import { ImportSkillsResultDialogComponent } from '../import-skills-result-dialog/import-skills-result-dialog.component';
import { ImportSkillsSummaryDialogComponent } from '../import-skills-summary-dialog/import-skills-summary-dialog.component';
import { ImportSkillsUploadFileDialogComponent } from '../import-skills-upload-file-dialog/import-skills-upload-file-dialog.component';

export const importSkillsStepComponentMap: Record<ImportSkillsStep, ImportSkillsStepI> = {
  intro: {
    dialogComponent: ImportSkillsIntroDialogComponent,
    dialogConfig: { width: DialogWidth.Large, containerOptions: { fullscreenOnMobile: true } },
  },
  upload_file: {
    dialogComponent: ImportSkillsUploadFileDialogComponent,
    dialogConfig: { width: DialogWidth.Large, containerOptions: { fullscreenOnMobile: true } },
  },
  loading: {
    dialogComponent: ImportSkillsLoadingDialogComponent,
    dialogConfig: {
      width: DialogWidth.Large,
      containerOptions: { fullscreenOnMobile: true },
      disableCloseOnBackdrop: true,
      disableClose: true,
      showCloseButton: false,
    },
  },
  summary: {
    dialogComponent: ImportSkillsSummaryDialogComponent,
    dialogConfig: {
      width: DialogWidth.Large,
      containerOptions: { fullscreenOnMobile: true },
    },
  },
  result: {
    dialogComponent: ImportSkillsResultDialogComponent,
    dialogConfig: {
      width: DialogWidth.SmallX,
      containerOptions: { fullscreenOnMobile: true },
    },
  },
};
